import type { GeofenceAnomalyRow } from '@cls/shared';
import { CompSection, EmptyOk } from '../CompSection.js';

interface Props {
  rows: GeofenceAnomalyRow[];
  limit?: number;
}

export function GeofenceSection({ rows, limit = 20 }: Props) {
  const visible = rows.slice(0, limit);
  return (
    <CompSection title={`📍 Geofence Anomalies (${rows.length})`} type="warn">
      {rows.length ? (
        <table>
          <thead>
            <tr>
              <th>Worker</th>
              <th>Project</th>
              <th>Type</th>
              <th>Date/Time</th>
              <th>Distance</th>
            </tr>
          </thead>
          <tbody>
            {visible.map((r) => (
              <tr key={r.id}>
                <td>{r.workerName}</td>
                <td>{r.projectLabel}</td>
                <td>{r.type.toUpperCase()}</td>
                <td style={{ fontSize: 10 }}>{new Date(r.timestamp).toLocaleString('en-GB')}</td>
                <td style={{ color: 'var(--warn)' }}>{r.distanceM != null ? `${Math.round(r.distanceM)}m` : '?m'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyOk message="No geofence anomalies" />
      )}
    </CompSection>
  );
}
